import styled, { css } from 'styled-components';
import { desktop1920pxOrWider, tabletOrWider } from '../../layout/breakpoint-utils';
import { PlainModal, PlainModalProps } from '../plain-modal';

/*
This modal extends PlainModal and is meant to be used as a template for modals with embedded forms.

Use the three components in form-modal-parts.tsx to build the modal:
  1. FormModalTopBar for titles and a dedicated separate background for the close button. 
     NOTE: The close button is rendered by PlainModal on top of the FormModalTopBar.
  2. FormModalContent for the actual form, will be scrollable.
  3. FormModalBottomBar for CTA buttons and backlinks.
*/

export const FormModal = (props: PlainModalProps) => {
  return <StyledModal {...props} />;
};

const StyledModal = styled(PlainModal)`
  .ReactModal__Content {
    background-color: white;
    padding: 0;
    ${tabletOrWider(css`
      width: 90vw;
      max-width: 780px;
    `)}
    ${desktop1920pxOrWider(css`
      max-width: 840px;
    `)}
  }
`;
